import { createContext } from 'react';

import { Context } from '../../../types';
import { SupplierService } from '../types';
import api from '../api';
import { getContextDefaultValues } from '../../providersDataManager';

export default createContext<Context<SupplierService>>(getContextDefaultValues(api));
